<template>
    <el-dialog
        class="shipping-rule-form"
        :visible.sync="shippingRuleDetailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        :modal-append-to-body="false"
        append-to-body
        width="900px"
        title="Shipping Rule Detail"
    >
        <el-form
            ref="form"
            label-width="90px"
            style="padding-bottom: 20px"
        >
            <el-row :gutter="20">
                <el-col :span="18">
                    <el-form-item
                        label="Rule Name :"
                        prop="name"
                        size="small"
                    >
                        {{tableItem.name}}
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="24">
                    <div style="font-weight: bold; margin-bottom: 10px; color: #333; text-indent: 12px;">Selected</div>
                    <div style="border: 1px solid #DCDFE6; padding: 20px; height: 300px; overflow-y: auto;">
                        <el-row style="display: flex; align-items: start;">
                            <el-col :span="5" style="line-height: 28px; font-size: 12px;">
                                Country :
                            </el-col>
                            <el-col :span="19" style="display: flex; flex-wrap: wrap; gap: 4px;">
                                <el-tag v-for="c in tableItem.country" :key="c" style="margin-left: 0">{{countries.find(cc => cc.value === c.toString()).label}}</el-tag>
                            </el-col>
                        </el-row>
                        <el-row style="display: flex; align-items: start; line-height: 28px;">
                            <el-col :span="5" style="font-size: 12px;">
                                Weight(g) :
                            </el-col>
                            <el-col class="weight-input" :span="19">
                                {{tableItem.weight_min}} - {{tableItem.weight_max}}
                            </el-col>
                        </el-row>
                        <el-row :style="`display: ${tableItem.shop.length > 0 && 'flex' || 'none'}; align-items: start;line-height: 28px;`">
                            <el-col :span="5" style="font-size: 12px;">
                                Store :
                            </el-col>
                            <el-col :span="19" style="display: flex; flex-wrap: wrap; gap: 4px;">
                                <el-tag v-for="c in tableItem.shop" :key="c" style="margin-left: 0">{{shops.find(cc => cc.value === c.toString()).label}}</el-tag>
                            </el-col>
                        </el-row>
                        <el-row style="display: flex; align-items: start;line-height: 28px;">
                            <el-col :span="5" style="font-size: 12px;">
                                Shipping Method :
                            </el-col>
                            <el-col :span="19">
                                {{tableItem.last_mile_name}}
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
            <div style="text-indent: 16px; font-size: 12px; margin-top: 20px">(When the above selection conditions are met, the setting action takes effect)</div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="shippingRuleDetailVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
        };
    },
    methods: {
        /**
         * 新增窗口关闭
         */
        closeDialog() {
            this.$emit("update:shippingRuleDetailVisible", false);
        },
        minusItems(index) {
            if (this.form.value.length <= 1) return;
            this.form.value.splice(index, 1);
        },
    },
    props: {
        shippingRuleDetailVisible: Boolean,
        tableItem: Object,
        countries: Array,
        shops: Array
    },
};
</script>
<style lang="scss">
.shipping-rule-form {
    .no-options-selector {
        .el-select__tags {
            flex-wrap: nowrap;
            overflow-x: hidden;
        }
        .el-select-dropdown {
            display: none!important;
        }
    }
    .weight-input {
        display:flex;
        justify-content: space-between;
        align-items: start;

        .el-input {
            input {
                text-align: center; 
            }
        }
    }
    .el-form-item__content {
        .el-select,
        .el-select--small {
            width: 100%;
        }
        .is-disabled {
            .el-input__inner {
                color: #606266;
            }
        }
    }
    .el-row {
        /* &:not(:last-child) {
            margin-bottom: 18px;
        } */
        &:only-child {
            margin-bottom: 0;
        }
        & + .el-row {
            margin-top: 18px;
        }
    }
}
</style>
